import { createFileRoute } from "@tanstack/react-router"
import { Container, Stack, Title, Text, Group, Paper } from "@mantine/core"
import { IconFileText } from "@tabler/icons-react"
import { ActionWizard } from "../components/action/wizard/ActionWizard"
import { PublicMetrics } from "../components/action/metrics/PublicMetrics"
import { ShareButtons } from "@/components/ui/ShareButtons"
import { SEO } from "@/components/seo/SEO"
import { PageCTASection } from "@/components/ui/PageCTASection"
import { useEffect } from "react"

export const Route = createFileRoute("/action")({
  component: TakeActionPage,
})

function TakeActionPage() {
  // Track Google Ads conversion when page loads
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-1002380567/pdHXCPbdi_gYEJe6_N0D",
      })
    }
  }, [])

  return (
    <>
      <SEO
        title="Take Action"
        description="Join thousands of Americans calling for the release of unredacted Jeffrey Epstein case files. Contact your representatives and demand transparency."
        canonical="https://rtefn.com/action"
        keywords="contact representatives, demand transparency, take action, petition, advocacy, contact congress, Epstein file release, call your representative, civic action, government accountability action"
      />
      <Container size="xl" py="xl">
        <Stack gap="4xl">
          {/* Hero Section */}
          <Stack gap="lg" ta="center">
            <Title order={1} size="3rem" fw={700} style={{ lineHeight: 1.2 }}>
              Demand Transparency
            </Title>
            <Text size="xl" maw={600} mx="auto" c="dimmed" ta="center">
              Join thousands of Americans calling for the release of unredacted Jeffrey Epstein case files. Your voice
              matters in the fight for accountability and justice.
            </Text>
          </Stack>

          {/* Public Metrics - Now shows real data or building momentum message */}
          <PublicMetrics />

          {/* Action Wizard */}
          <ActionWizard />

          {/* Share Section */}
          <Paper p="xl" radius="lg" withBorder>
            <Stack gap="md" ta="center">
              <Title order={3} size="1.5rem">
                Spread the Word
              </Title>
              <Text size="base" c="dimmed" maw={500} mx="auto">
                Help amplify this cause by sharing with your network. Every share increases pressure for transparency.
              </Text>
              <Group justify="center" mt="md">
                <ShareButtons
                  text="Join the call for transparency in the Epstein case. Demand the release of all unredacted files."
                  size="lg"
                  variant="default"
                />
              </Group>
            </Stack>
          </Paper>

          {/* Call to Action */}
          <PageCTASection contextualAction={{ href: "/documents", label: "View Documents", icon: IconFileText }} />
        </Stack>
      </Container>
    </>
  )
}
